import admin1        from '@/components/admin/UsersList.vue'
import admin2        from '@/components/admin/LabelLayout.vue'
import admin3        from '@/components/rt/StoreDeskFiscalPrinter.vue'
//import admin4        from '@/components/frontOffice/cart/cartTable.vue'

const flag = true


const menuId = 'ad1'
const routes = [
    {
        path        : '/admin1',
        name        : 'ad1',
        component   : admin1,
        meta        : { name : 'Lista Utenti', divider:0, visible : flag ,icon : 'fas fa-users',menu:menuId,color:'blue'},
        
    },
    
    {
        path        : '/admin2',
        name        : 'ad2',
        component   : admin2,
        meta        : { name : 'Layout etichetta', visible : flag ,icon : 'fas fa-ruler-combined',menu:menuId,color:'green'},
        
    },
    {
        path        : '/admin3',
        name        : 'ad3',
        component   : admin3,
        meta        : { name : 'Stampante fiscale', 'skip' : true, visible : flag ,icon : 'fas fa-cash-register',menu:menuId,color:'brown'},
        
    },
    /*
    {
        path        : '/admin4',
        name        : 'ad4',
        component   : admin4,
        meta        : { name : 'TEST NEW CART', 'skip' : true, divider:1,visible : flag ,icon : 'fas fa-cash-register',menu:menuId,color:'brown'},
        
    }
*/
    
]

export default routes